import { getWorkerCompStatusLabel } from "../../../../../lib/labels";
import { formatDateLocal } from "../../../../../lib/script";
import { atpProvidersOptions } from "../../../../../lib/systemData";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import SimpleBoxDisplay from "../../../../common/SimpleBoxDisplay";
import CaseSummaryBox from "../CaseSummaryBox";

export default function WorkersCompSummary({primaryWorkerComp, classes}) {
    return <CaseSummaryBox title={'Worker Comp'} tabNumber={6}>
        {primaryWorkerComp && <>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Name'} value={primaryWorkerComp.insurance_carrier?.name}/>
                <SimpleBoxDisplay label={'Board Claim #'} value={primaryWorkerComp.board_claim_number}/>
                <SimpleBoxDisplay label={'Claim #'} value={primaryWorkerComp.claim_number}/>
            </div>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Work Comp Status'} value={getWorkerCompStatusLabel(primaryWorkerComp.worker_comp_status)}/>
            </div>
            {primaryWorkerComp.atp ? <div className={classes.row}>
                <CheckboxCell checked={primaryWorkerComp.atp} label={'ATP'} isDisabled={true} direction={'reverse'} />
                {primaryWorkerComp.atp_date && <SimpleBoxDisplay label={'ATP Date'} value={formatDateLocal(primaryWorkerComp.atp_date)}/>}
                {primaryWorkerComp.provider_id && <SimpleBoxDisplay label={'Provider Name'} value={atpProvidersOptions()?.find(item => item.value == primaryWorkerComp.provider_id)?.label}/>}
                {primaryWorkerComp.approved_treatment_areas &&<SimpleBoxDisplay label={'Approved Treatment Areas'} value={primaryWorkerComp.approved_treatment_areas}/>}
            </div> : ''}
        </>}
    </CaseSummaryBox>
}